<ng-template>
    <p>{{tip}}</p>
</ng-template>
